
import { PackageItem } from "@/types/package-item";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";

interface PackageInclusionsTableProps {
  items: PackageItem[];
  onEdit: (item: PackageItem) => void;
  onDelete: (id: string) => void;
}

export const PackageInclusionsTable = ({ items, onEdit, onDelete }: PackageInclusionsTableProps) => {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-right">النص بالعربية</TableHead>
            <TableHead className="text-right">النص بالإنجليزية</TableHead>
            <TableHead className="text-right">العمليات</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length > 0 ? (
            items.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="font-medium">{item.text_ar}</TableCell>
                <TableCell dir="ltr" className="text-left">{item.text_en}</TableCell>
                <TableCell>
                  <div className="flex gap-2 justify-start">
                    <Button variant="ghost" size="sm" onClick={() => onEdit(item)}>
                      <Pencil className="h-4 w-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDelete(item.id)}
                      className="text-red-600 hover:text-red-700"
                    >
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} className="text-center h-24">
                لا توجد بنود.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
